import { isSyntheticCheckMode } from '@canvas/testing/synthetic-check-mode';

import { PreloaderManager } from './preloader-manager';

// Disable preloading in Pollinator to avoid running out of memory
export const preloader = new PreloaderManager(!isSyntheticCheckMode());

export { PreloaderPriority } from './preloader-manager';
export type { PreloaderItemInit } from './preloader-manager';
